// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.check-circle {
  display: flex;
  position: relative;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
}
.check-circle .container {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.check-circle__text {
  margin-left: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.check-circle .container input {
  opacity: 0;
  height: 0;
  width: 0;
}
.check-circle .checkmark {
  height: 20px;
  width: 20px;
  background-color: white;
  border: 1.5px solid #e1e1e1;
  border-radius: 200px;
}
.check-circle .roundedCheckmark {
  border-radius: 30px;
}
.check-circle .container:hover input ~ .checkmark {
  background-color: white;
}
.check-circle .container input:checked ~ .checkmark {
  background: #49ae9e;
  border: 1.5px solid #49ae9e;
}
.check-circle .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.check-circle .container input:checked ~ .checkmark:after {
  display: block;
}
.check-circle .container .checkmark:after {
  left: 5px;
  width: 5px;
  margin-top: 2px;
  margin-left: 1px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}`, "",{"version":3,"sources":["webpack://./src/components/check-circle/check-circle.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AACR;AAEI;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAR;AAGI;EACI,UAAA;EACA,SAAA;EACA,QAAA;AADR;AAII;EACI,YAAA;EACA,WAAA;EACA,uBAAA;EACA,2BAAA;EACA,oBAAA;AAFR;AAII;EACI,mBAAA;AAFR;AAKI;EACI,uBAAA;AAHR;AAMI;EACI,mBAAA;EACA,2BAAA;AAJR;AAOI;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AALR;AAQI;EACI,cAAA;AANR;AASI;EACI,SAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EAGA,wBAAA;AAPR","sourcesContent":[".check-circle {\n    display: flex;\n    position: relative;\n    cursor: pointer;\n    font-size: 22px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n\n    .container {\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n    }\n\n    &__text {\n        margin-left: 5px;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #333333;\n    }\n\n    .container input {\n        opacity: 0;\n        height: 0;\n        width: 0;\n    }\n\n    .checkmark {\n        height: 20px;\n        width: 20px;\n        background-color: white;\n        border: 1.5px solid #e1e1e1;\n        border-radius: 200px;\n    }\n    .roundedCheckmark {\n        border-radius: 30px;\n    }\n\n    .container:hover input ~ .checkmark {\n        background-color: white;\n    }\n\n    .container input:checked ~ .checkmark {\n        background: #49ae9e;\n        border: 1.5px solid #49ae9e;\n    }\n\n    .checkmark:after {\n        content: '';\n        position: absolute;\n        display: none;\n    }\n\n    .container input:checked ~ .checkmark:after {\n        display: block;\n    }\n\n    .container .checkmark:after {\n        left: 5px;\n        width: 5px;\n        margin-top: 2px;\n        margin-left: 1px;\n        height: 10px;\n        border: solid white;\n        border-width: 0 2px 2px 0;\n        -webkit-transform: rotate(45deg);\n        -ms-transform: rotate(45deg);\n        transform: rotate(45deg);\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
